<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  created() {
    // this.$wx.miniProgram.getEnv(function(res) {
    //   alert(res.miniprogram)
    // })
  }
}
</script>

<style lang="scss">
html {
  font-size: 13.3333333333vw;
}
</style>
